/**
 * Collection badges carousel for collection hero
 * Reads hairgivers.category_badges metafield (list.collection_reference) and renders a swipeable row.
 */

(async () => {
  if (!customElements.get('collection-badges')) {
    const { default: Swiper, Navigation } = await import('swiper');
    Swiper.use([Navigation]);

    class CollectionBadges extends HTMLElement {
      constructor() {
        super();
        this.swiperEl = this.querySelector('.swiper');
        this.init();

        if (Shopify.designMode) {
          window.addEventListener('shopify:section:load', () => {
            this.swiper.update();
          });
        }
      }

      init() {
        this.swiper = new Swiper(this.swiperEl, {
          loop: false,
          slidesPerView: 'auto',
          spaceBetween: 12,
          navigation: {
            prevEl: this.querySelector('.collection-badges__nav--prev'),
            nextEl: this.querySelector('.collection-badges__nav--next'),
          },
          on: {
            init: (s) => this.updateNav(s),
            slideChange: (s) => this.updateNav(s),
            progress: (s) => this.updateNav(s),
          },
        });
      }

      updateNav(swiper) {
        const prev = this.querySelector('.collection-badges__nav--prev');
        const next = this.querySelector('.collection-badges__nav--next');
        if (prev) prev.hidden = swiper.isBeginning;
        if (next) next.hidden = swiper.isEnd;
      }
    }

    customElements.define('collection-badges', CollectionBadges);
  }
})();
